var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFpkGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9662 11.8923V14.7847C9.9662 15.1028 9.70589 15.3631 9.38774 15.3631H7.65235V2.63693H9.38774C9.70589 2.63693 9.9662 2.89724 9.9662 3.2154V6.10771C9.9662 6.87129 11.1231 6.87129 11.1231 6.10771V3.2154C11.1231 2.26093 10.3422 1.48001 9.38774 1.48001H7.48459C7.19536 0.988314 6.66317 0.808991 6.18305 0.942037L1.40494 2.27829C0.652941 2.48653 0.132324 3.18647 0.132324 3.97897V14.0211C0.132324 14.8136 0.658726 15.5135 1.41073 15.7218L6.18883 17.058C6.66896 17.1911 7.20115 17.0117 7.49038 16.5201H9.39352C10.348 16.5201 11.1289 15.7391 11.1289 14.7847V11.8923C11.1289 11.1288 9.97198 11.1288 9.97198 11.8923H9.9662ZM1.71731 14.6053C1.46279 14.5359 1.28925 14.293 1.28925 14.0211V3.97897C1.28925 3.70709 1.46857 3.46414 1.71731 3.39472L6.49542 2.07583V15.9416L1.71731 14.6111V14.6053Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9941 8.16705L13.7013 5.68544C14.2624 5.17061 15.0491 6.02095 14.4822 6.53578L12.394 8.42157H17.5596C18.3232 8.42157 18.3232 9.5785 17.5596 9.5785H12.4229L14.4822 11.4643C15.0433 11.9791 14.2624 12.8352 13.7013 12.3146L10.9941 9.83302C10.4966 9.37604 10.4966 8.61825 10.9941 8.16126V8.16705Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.18164 8.42156V9.57848C4.18164 10.3421 5.33857 10.3421 5.33857 9.57848V8.42156C5.33857 7.65798 4.18164 7.65798 4.18164 8.42156Z",
    fill: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M6.75477 1.6615L0.938477 3.16348V14.668L6.75477 16.905V1.6615Z",
    fill: "#8C8C8C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpkGreyIcon);
export default __webpack_public_path__ + "static/media/fpk-grey-icon.0a9110b6f6eb4967c16541fd7b5fa0e6.svg";
export { ForwardRef as ReactComponent };